import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { Deck } from "../cards/Deck";
import { EngineStatus } from "./EngineStatus";
import { LocksCounter } from "./LocksCounter";
import { EventType } from "../../../Types";
import { BoardScene } from "../BoardScene";

export class HUD extends Phaser.GameObjects.Container {

    private deckCardsCounterLabel: Phaser.GameObjects.Text;
    private engineStatus: EngineStatus;
    private deckCardsCounter: number;
    private locksCounter: LocksCounter;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT / 2;

        this.scaleY = GameVars.scaleY;
        this.deckCardsCounter = 0;

        const cardsCounterBackground = new Phaser.GameObjects.Image(this.scene, 140, -460, "texture_atlas_1", "tab_cards");
        this.add(cardsCounterBackground);

        this.deckCardsCounterLabel = new Phaser.GameObjects.Text(this.scene, cardsCounterBackground.x - 14, cardsCounterBackground.y - 8, this.deckCardsCounter.toString(), { fontFamily: "AlmendraBold", color: "#663227", fontSize: "46px" });
        this.deckCardsCounterLabel.setOrigin(.5);
        this.add(this.deckCardsCounterLabel);

        GameVars.eventsDispatcher.addEventListener(EventType.CARD_ADDED_TO_DECK, this.onCardAddedToDeck, this);

        if (GameConstants.DEBUG) {
            this.engineStatus = new EngineStatus(this.scene);
            this.add(this.engineStatus);
        }
    }

    public update(): void {

        if (GameConstants.DEBUG) {
            this.engineStatus?.update();
        }

        this.locksCounter?.update();
    }

    public startGame(): void {

        const state = GameVars.cardCrawlEngine.getState();
        const deck = state.deck;

        this.deckCardsCounter = state.upperTableau.reduce((count: number, item: CardCrawl.CardData) => item && item.uiData.spawned ? count + 1 : count, 0);
        this.deckCardsCounter += deck.length;

        this.deckCardsCounterLabel.text = this.deckCardsCounter.toString();

        this.locksCounter = new LocksCounter(this.scene);

        Deck.currentInstance.addLocksCounter(this.locksCounter);
    }

    public onGameOver(): void {

        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Linear,
            duration: 400,
            delay: GameVars.victory ? BoardScene.DELAY_GAME_OVER : 0,
            onComplete: () => {
                this.visible = false;
            },
            onCompleteScope: this
        });
    }

    public onActionProcessed(): void {
        //
    }

    public onCardDealt(): void {
        
        this.deckCardsCounter --;

        this.deckCardsCounterLabel.setText(this.deckCardsCounter.toString());
    }

    private onCardAddedToDeck(): void {

        if (this.deckCardsCounterLabel) {
            this.deckCardsCounter ++;
            this.deckCardsCounterLabel.text = this.deckCardsCounter.toString();
        }
    }
}
